import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_NAME, SECTION_IDS, IMAGES } from "../utils/constants";
import { trackEvent } from "../utils/analytics";

const Hero = () => {
    const { t } = useTranslation();

    const scrollToSection = (sectionId) => {
        // Track the button click event
        trackEvent('Navigation', 'Click', `Hero - ${sectionId} button`);

        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <section className="bg-pastita-orange text-white py-12 sm:py-16 md:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
                    <div className="md:flex-1 md:pr-8">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight">
                            {APP_NAME}. <i>{t('hero.title')}</i>
                        </h1>
                        <p className="text-lg sm:text-xl mb-6 sm:mb-8 opacity-90 max-w-2xl">
                            {t('hero.description')}
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 sm:space-x-4">
                            <button
                                onClick={() => scrollToSection(SECTION_IDS.SIMULATOR)}
                                className="bg-white text-pastita-orange px-6 sm:px-8 py-3 hover:text-white rounded-lg hover:bg-pastita-sand transition-colors font-semibold w-full sm:w-auto text-center">
                                {t('common.buttons.trySimulator')}
                            </button>
                            <button
                                onClick={() => scrollToSection(SECTION_IDS.MENU)}
                                className="border-2 border-white text-white px-6 sm:px-8 py-3 rounded-lg hover:bg-pastita-sand hover:border-pastita-sand hover:text-white transition-colors font-semibold w-full sm:w-auto text-center">
                                {t('common.buttons.viewMenu')}
                            </button>
                        </div>
                    </div>

                    <div className="md:flex-1 flex justify-center md:justify-end mt-8 md:mt-0">
                        <div className="relative">
                            <div
                                className="w-64 h-48 sm:w-72 sm:h-54 md:w-80 md:h-60 bg-white bg-opacity-10 rounded-lg flex items-center justify-center">
                                <img
                                    src={IMAGES.HERO_IMAGE}
                                    alt={t('hero.imageAlt')}
                                    className="w-fill h-fill object-contain rounded-lg shadow-lg"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
